var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTeacherFeedbackSmallBadge = function SvgTeacherFeedbackSmallBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    strokeWidth: 1.5,
    fill: "#DBFADF",
    cx: 8,
    cy: 8,
    r: 5.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 5 .058.003A.5.5 0 0 1 11 5.5v5l-.003.058A.5.5 0 0 1 10.5 11h-5l-.058-.003A.5.5 0 0 1 5 10.5v-5l.003-.058A.5.5 0 0 1 5.5 5h5z",
    fill: "#378142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EA15A",
    d: "M10 6H6v4h4z"
  }))));
};

export default SvgTeacherFeedbackSmallBadge;